module.exports = __webpack_public_path__ + "img/forgot-password.032b9fa4.png";